
export const GTM_STATE_KEY = '__gtm_state__';

const buildGtmState = (state: State.Root) => {
  const data = state.user?.data;
  const pad = state.user?.personAccountData;
  const cartValue = state.cart?.value;
  const receipt = state.checkout?.receipt?.payReceipt?.receipt;

  return {
    app: { appInitialized: !!state.app?.appInitialized },
    user: state.user
      ? {
          isAuth: state.user.isAuth,
          sfmcLink: state.user.sfmcLink,
          data: data
            ? {
                userId: data.userId,
                AICPAUID: data.AICPAUID,
                roles: data.roles,
              }
            : undefined,
          personAccountData: pad
            ? {
                id: pad.id,
              }
            : undefined,
        }
      : undefined,
    cart: state.cart
      ? {
          isCartFetched: state.cart.isCartFetched,
          value: cartValue
            ? {
                lineItems: cartValue.lineItems,
                totalPrice: cartValue.totalPrice,
              }
            : undefined,
        }
      : undefined,
    products: { productItem: state.products?.productItem },
    checkout: {
      receipt: receipt
        ? {
            payReceipt: {
              receipt: {
                orderNumber: receipt.orderNumber,
                invoiceNumber: receipt.invoiceNumber,
                amount: receipt.amount,
                currency: receipt.currency,
              },
            },
          }
        : undefined,
    },
  };
};

export const installGtmDataLayer = (store: { getState: () => State.Root }): void => {
  if (typeof window === 'undefined') return;

  Object.defineProperty(window, GTM_STATE_KEY, {
    configurable: true,
    get: () => buildGtmState(store.getState()),
  });
};